import { WineAttributes } from "../../types";
import { VinoDataWine } from "../../types/vino-data-types";

export const WineAttributesFromVinoDataWine = (
  wine: VinoDataWine
): WineAttributes => {
  let _preservatives = wine.preservatives ? wine.preservatives : [];
  if (wine.preservatives && wine.preservatives.indexOf("Unavailable") > -1)
    _preservatives = [];
  return {
    vintage: wine.vintage,
    style: wine.style,
    cellaring: wine.cellaring,
    alcoholByVolume: wine.alcoholByVolume,
    closure: wine.closure,
    servingTemp: wine.servingTemp ? wine.servingTemp + "°C" : "",
    blendInfo: wine.blendInfo,
    preservatives: _preservatives,
    palateWeight: wine.palateWeight,
    texture: wine.texture,
    intensity: wine.intensity,
  };
};
